export default __webpack_public_path__ + "static/media/turkey.72a88db2.png";